<template>
  <div
    v-if="luggagePolicies?.length && policy"
    class="policy py-1 mt-2"
  >
    <p
      v-if="policy.policy_carryon"
      class="m-0"
    >
      <span
        class="text-black"
        data-i18n="charterLuggageCarryOn"
      >{{ $t('charterLuggageCarryOn') }} &nbsp;</span>
      <span>
        {{ policy.policy_carryon }}
      </span>
    </p>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'AirlineLuggagePolicy',

  props: {
    carrierCode: {
      type: String,
      required: true,
    },

    luggagePolicies: {
      type: Array,
      default: null,
    },
  },

  computed: {
    policy () {
      return this.luggagePolicies?.find(policy => policy.airline === this.carrierCode)
    },
  },
})
</script>

<style scoped lang="scss">
.policy {
  font-size: 0.85rem;
  color: theme('colors.text-gray');
}
</style>
